import styled from 'styled-components';

import {i18n} from '@yourcoach/i18n';

import IconSvg from '../../../assets/icons/primary/Info Circle.svg';
import {alert} from '../../../components/alert';
import {getColor, ms, square} from '../../../styles';
import {platform} from '../../../utils/platform';

const Icon = styled(IconSvg).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(72)};
  margin-block-end: ${ms(25)};
  align-self: center;
`;

export const deleteCourseConfirmAlert: () => Promise<boolean> = () => {
  return alert.show({
    beforeTitleSlot: () => <Icon />,
    buttons: [
      {
        label: i18n.t('shared:yes'),
        onAwaitableClick: resolve => resolve(true),
        scheme: 'error',
      },
      {
        label: i18n.t('shared:no_close'),
        onAwaitableClick: resolve => resolve(false),
        scheme: 'gray',
      },
    ],
    isDismissible: true,
    message: i18n.t('shared:all_data_will_be_deleted'),
    title: i18n.t('shared:are_you_sure'),
    variant: platform.isNative ? 'promo' : undefined,
  });
};
